import React from 'react';
import './Footer.css';

function Footer({ isEnglish }) {
  return (
    <footer className="footer">
      <div className="footer-content">
        <p className="footer-title">
          {isEnglish ? 'Kanazawa Stay Akebono' : '金沢之旅宿 あけぼの'}
        </p>
        <p className="footer-copy">
          © 2025 KICKs Inc. / {isEnglish ? 'Some images provided by Kanazawa City' : '一部画像提供：金沢市'}
        </p>

        <nav className="footer-links">
          <a href={isEnglish ? '/en/terms' : '/terms'} className="footer-link">
            {isEnglish ? 'Legal Notice' : '特商法に基づく表記'}
          </a>
          <span className="footer-separator">/</span>

          <a href={isEnglish ? '/en/privacy' : '/privacy'} className="footer-link">
            {isEnglish ? 'Privacy Policy' : 'プライバシーポリシー'}
          </a>
          <span className="footer-separator">/</span>

          <a href={isEnglish ? '/en/rules' : '/rules'} className="footer-link">
            {isEnglish ? 'Accommodation Agreement' : '宿泊約款'}
          </a>
          <span className="footer-separator">/</span>

          <a href={isEnglish ? '/en/contact' : '/contact'} className="footer-link">
            {isEnglish ? 'Contact Us' : 'お問い合わせ'}
          </a>
          <span className="footer-separator">/</span>

          <a
            href="https://kicks-inc.jp"
            className="footer-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            KICKs Inc.
          </a>
        </nav>

        {/* Instagramリンク追加 */}
        <div className="footer-sns">
          <a
            href="https://www.instagram.com/kanazawastay_akebono/"
            target="_blank"
            rel="noopener noreferrer"
            className="instagram-link"
            aria-label="Instagram"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              fill="currentColor"
              viewBox="0 0 24 24"
              className="instagram-icon"
            >
              <path d="M12 2.2c3.2 0 3.6 0 4.8.1 1.2.1 2 .3 2.5.6.6.3 1.1.8 1.4 1.4.3.5.5 1.3.6 2.5.1 1.2.1 1.6.1 4.8s0 3.6-.1 4.8c-.1 1.2-.3 2-.6 2.5-.3.6-.8 1.1-1.4 1.4-.5.3-1.3.5-2.5.6-1.2.1-1.6.1-4.8.1s-3.6 0-4.8-.1c-1.2-.1-2-.3-2.5-.6-.6-.3-1.1-.8-1.4-1.4-.3-.5-.5-1.3-.6-2.5C2.2 15.6 2.2 15.2 2.2 12s0-3.6.1-4.8c.1-1.2.3-2 .6-2.5.3-.6.8-1.1 1.4-1.4.5-.3 1.3-.5 2.5-.6C8.4 2.2 8.8 2.2 12 2.2m0-2.2C8.7 0 8.3 0 7 .1 5.7.2 4.5.5 3.7.9 2.8 1.3 2.1 2 1.5 2.8.9 3.7.6 4.9.5 6.2.4 7.5.4 7.9.4 12s0 4.5.1 5.8c.1 1.3.4 2.5.8 3.4.4.9 1.1 1.6 2 2.2.8.5 2 0.8 3.3.9 1.3.1 1.7.1 5.8.1s4.5 0 5.8-.1c1.3-.1 2.5-.4 3.4-.8.9-.4 1.6-1.1 2.2-2 .5-.8.8-2 .9-3.3.1-1.3.1-1.7.1-5.8s0-4.5-.1-5.8c-.1-1.3-.4-2.5-.8-3.4-.4-.9-1.1-1.6-2-2.2C19.5.5 18.3.2 17 .1 15.7 0 15.3 0 12 0zm0 5.8a6.2 6.2 0 1 0 0 12.4 6.2 6.2 0 0 0 0-12.4zm0 10.2a4 4 0 1 1 0-8.1 4 4 0 0 1 0 8.1zm6.4-11.6a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"/>
            </svg>
          </a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
